import { TextField, InputAdornment, Collapse } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { IUserFormInput, onReplaceSpecialChars } from "../../pages/UserForm";

const UserFormTextField = ({ label, value, mandatory, onInputChange, characterLimit }: IUserFormInput) => {
  const [currentValue, setCurrentValue] = useState<string>("");

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const extraProps: any = {};
  let extraLabel = "";
  if (characterLimit) {
    const currentCharacters = (currentValue ?? "").length;
    extraProps.inputProps = { maxLength: characterLimit };
    extraProps.InputProps = {
      endAdornment: (
        <InputAdornment position="end">
          {currentCharacters}/{characterLimit}
        </InputAdornment>
      ),
    };

    extraLabel = ` (Máx. ${characterLimit} caracteres)`;
  }

  return (
    <TextField
      type="new-password"
      autoComplete="new-password"
      id={onReplaceSpecialChars(label.toLowerCase().replaceAll(" ", "-"))}
      fullWidth
      label={label + extraLabel}
      variant="outlined"
      required={mandatory}
      value={currentValue}
      onBlur={() => onInputChange(currentValue ?? "")}
      onChange={(event: any) => setCurrentValue(event.target.value)}
      {...extraProps}
    />
  );
};

export default UserFormTextField;
